import { HttpRequest, HttpEvent, HttpHeaders, HttpHandlerFn } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  private readonly authService = inject(AuthService);

  handle401(request: HttpRequest<any>, next: HttpHandlerFn, locale: string): Observable<HttpEvent<any>> {
    return this.authService.refreshAccessToken().pipe(
      switchMap((response) => {
        let headers = new HttpHeaders({ 'Cache-Control': 'no-cache', 'Expires': '0', 'Content-Type': 'application/json' });
        headers = headers.append('Accept-Language', locale);
        headers = headers.append('Authorization', `Bearer ${response.access_token}`);
        const clone = request.clone({
          headers: headers,
          withCredentials: true
        })
        return next(clone);
      }),
      catchError((error) => {
        this.authService.handleUnauthorized();
        return throwError(() => error);
      })
    );
  }

}
